import { render, staticRenderFns } from "./MaintenanceItemPackageForm.vue?vue&type=template&id=3b965999&scoped=true"
import script from "./MaintenanceItemPackageForm.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemPackageForm.vue?vue&type=script&lang=ts"
import style0 from "./MaintenanceItemPackageForm.vue?vue&type=style&index=0&id=3b965999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b965999",
  null
  
)

export default component.exports